import type { PayloadAction } from '@reduxjs/toolkit';
import type { TenantConfiguration } from '@/features/system/store/types/TenantConfiguration';
import type { HttpServiceResponse } from '@/services/HttpService/types';
import { call, put, takeLatest } from 'redux-saga/effects';
import { LocalStorageVariables } from '@/enums/LocalStorageVariables';
import HttpService from '@/services/HttpService/HttpService';
import { getTenantConfiguration, getTenantConfigurationSuccess, processQueueOfActions } from '../store/systemSlice';

function* getTenantConfigurationSaga() {
  try {
    const { data }: HttpServiceResponse<TenantConfiguration> = yield call(
      HttpService.get,
      `${import.meta.env.VITE_BLOB_STORAGE_URL}/${import.meta.env.VITE_BLOB_STORAGE_TENANT_CONFIG_FILE_PATH}`,
      {},
      {
        baseURL: '/',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
        },
      },
    );

    localStorage.setItem(LocalStorageVariables.TenantConfiguration, JSON.stringify(data || ''));
  } catch (error) {
    console.error(error);
    localStorage.setItem(LocalStorageVariables.TenantConfiguration, JSON.stringify(''));
  } finally {
    const tenantConfiguration = JSON.parse(localStorage.getItem(LocalStorageVariables.TenantConfiguration) || '');
    yield put(getTenantConfigurationSuccess(tenantConfiguration || null));
  }
}

function* processQueueOfActionsSaga({ payload }: PayloadAction<PayloadAction[]>) {
  const actions = payload;
  for (const action of actions) {
    yield put(action);
  }
}

export function* systemWatcher() {
  yield takeLatest(processQueueOfActions.type, processQueueOfActionsSaga);
  yield takeLatest(getTenantConfiguration.type, getTenantConfigurationSaga);
}
